/* globals Mustache */

import Mustache from 'mustache';
/**
 * FileInput element
 */
class FileInput {

  /**
   * @constructor
   * @param {HTMLInputElement} element element to bind file input logic
   * @throws {TypeError} throws an error if element parameter is not instance of HTMLInputElement
   */
  constructor( element ) {
    this._element = element;
    this._newFileButton = this._element.closest('.form-v10__field').querySelector('.form-v10__new-file-button');

    if( !(element instanceof HTMLInputElement ) ) {
      throw new TypeError('Given element is not a type of HTMLInputElement');
    }

    if (element.multiple && element.name.indexOf('[]') === -1) {
      element.name = element.name + '[]';
    }

    this._clearButton = this._element.parentNode.querySelector('.form-v10__clear-file-input');

    this._bind();
  }

  /**
   * Bind event listeners
   */
  _bind() {
    this._element.addEventListener('change', this._fileChangeEvent.bind(this));
    this._clearButton.addEventListener('click', this._onClearButtonClicked.bind(this));

    if (this._newFileButton) {
      this._newFileButton.addEventListener('click', this._onNewFileButtonClicked.bind(this));
    }
  }

  /**
   * Called when a clear button is called
   */
  _onClearButtonClicked() {
    this._element.value = '';
    this._element.dispatchEvent(new Event('change'));
  }

  /**
   * Called when a new file button is clicked
   */
  _onNewFileButtonClicked() {
    const formField = this._newFileButton.closest('.form-v10__field');
    const input = formField.querySelectorAll('input[type=file]')[0];

    const inputName = input.name;
    const inputIndex = formField.querySelectorAll(`input[name="${inputName}"]`).length;
    const inputId = `${input.id}_${inputIndex}`;

    const inputTemplate = document.querySelector('#file-input-template').innerHTML;
    const newInput = document.createElement('div');
    newInput.classList.add('form-v10__input');
    newInput.innerHTML = Mustache.render(inputTemplate, { id: inputId, name: inputName });

    formField.insertBefore(newInput, this._newFileButton);

    this._initSingleFileInput(newInput.querySelector(`input[name="${inputName}"]`));

    this._showHideNewFileButton();
  }

  /**
   * Show and hide new file button
   */
  _showHideNewFileButton() {
    if (this._newFileButton) {
      const allInputs = this._newFileButton.closest('.form-v10__field').querySelectorAll('input[type=file]');
      let showButton = true;

      allInputs.forEach(input => {
        if (!input.value) {
          showButton = false;
        }
      });

      if (showButton) {
        this._newFileButton.style.display = 'block';
      } else {
        this._newFileButton.style.display = 'none';
      }
    }
  }

  /**
   * Handle file input change event
   * @param {HTMLElement} input input element
   */
  _fileChangeEvent(input) {
    if( !(input instanceof HTMLInputElement ) ) {
      input = this._element;
    }

    const formField = input.closest('.form-v10__field');

    if (input.value) {
      input.classList.add('file-added');

      if (input.multiple) {
        this._showHideNewFileButton();
      }
    } else {
      input.classList.remove('file-added');

      if (input.multiple) {
        if (formField.querySelectorAll('input[type=file]').length > 1) {
          input.closest('.form-v10__input').remove();
        }

        this._showHideNewFileButton();
      }
    }
  }

  /**
   * Init single file input
   * @param {HTMLElement} input input element
   */
  _initSingleFileInput(input) {
    const clearButton = input.parentNode.querySelector('.form-v10__clear-file-input');

    if (input.multiple && input.name.indexOf('[]') === -1) {
      input.name = input.name + '[]';
    }

    input.addEventListener('change', (event) => {
      this._fileChangeEvent(event.currentTarget);
    });

    clearButton.addEventListener('click', function(e) {
      input.value = '';
      input.dispatchEvent(new Event('change'));
    });
  }

}

export default FileInput;
